/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 14:42:21
 * @LastEditTime: 2022-01-03 15:06:49
 * @LastEditors: wangshengqiang
 * @Description: 组件出口
 */
import './Toolbar.less';
export { default as CustomerService } from './components/CustomerService';
export { default as SimpleRemark } from './components/SimpleRemark';
export { default as DetailRemark } from './components/DetailRemark';
export { default as Toolbar } from './Toolbar';
export { default } from './Toolbar.js';